import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";

import { HttpClient } from "@angular/common/http";

import * as L from "leaflet";

import { TileLayerOptions } from "leaflet";
import { AdminService } from "src/app/admin/services/admin.service";



export interface INewTileLayerOptions extends TileLayerOptions {

  id?: string;

}



@Component({

  selector: 'app-india-map',

  templateUrl: './india-map.component.html',

  styleUrls: ['./india-map.component.scss']

})

export class IndiaMapComponent implements OnInit {

  @Input() isStateView: boolean = true;

  @Input() disableDragging: boolean = true;

  @Input() isLegendsVisible: boolean = true;

  @Input() statesData: any = [];

  @Input() mapData: any = [];

  @Input() districtsData: any = [];



  @Output() districtApiTrigger: any = new EventEmitter();



  loadLegends: boolean = true;



  constructor(private http: HttpClient,

    private commonService: AdminService

  ) { }



  districtBoundaries: any;

  stateBoundaries: any;

  // callApi:boolean = true;

  selectedLayer: any;

  districtData: any[] = [];

  HEATMAP: any;





  async ngOnInit(): Promise<void> {

    // const districtResponse = await fetch('../../assets/Const_Json/districts_boundaries.json');

    // this.districtBoundaries = await districtResponse.json();

    // const stateResponse = await fetch(

    //   '../../assets/Const_Json/state_boundaries.json'

    // );

    // this.stateBoundaries = await stateResponse.json();


    await this.commonService.getStatesGeoJson().then(res => {

      this.stateBoundaries = res.stateBoundaries;

      this.districtBoundaries = res.districtBoundaries;

    })
    this.makeMap(this.statesData);

    this.commonService.mapReset.subscribe(res => {

      this.handleMapBackButton();

    })



    console.log('oninitdistrict', this.districtsData);

    console.log(this.districtBoundaries);

  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changesMap=====>", changes);
    if (changes.statesData && changes.statesData.currentValue) {

      this.statesData = changes.statesData.currentValue;
      console.log("changesMap=====>", this.statesData);
      this.makeMap(this.statesData);

      // if (this.isStateView) {
      //   console.log('asasasaddfdfcx')
      //   this.makeMap(this.statesData);
      // }

    }

    if (changes['districtsData'] && changes['districtsData'].currentValue && changes['districtsData'].currentValue.length) {
      this.districtsData = changes['districtsData'].currentValue;

      if (!this.isStateView) {
        this.getDistrictHeatMapData(this.districtsData, this.HEATMAP);

      }

    }

  }



  /**
   * The function "makeMap" is used to create a map using Leaflet library in TypeScript, with the
   * ability to display state or district boundaries and add interactive features such as popups and
   * click events.
   * @param {any} statesArr - The `statesArr` parameter is an array of objects representing the states.
   * Each object in the array should have the following properties:
   * @param [stateName] - The state name is a string that represents the name of a specific state. It
   * is used to filter the data and display the map for that particular state.
   * @param [stateCode] - The stateCode parameter is a string that represents the code of a state.
   */
  makeMap(statesArr: any, stateName = '', stateCode = '') {

    console.log("call Map", statesArr);

    const mapContainerId = `mapContainer`;

    let heatmap: any = null;

    let statesList = statesArr;

    let geoJson, districts, state;

    if (this.isStateView) {

      document.getElementById(

        mapContainerId

      )!.outerHTML = `<div id='mapContainer' style="height: 89%; border-radius: 0 0 8px 8px;" class=" mt-2 bg-light shadow-map">
      </div>`;

      document.getElementById(mapContainerId)!.innerHTML = '';
      geoJson = this.stateBoundaries;

      heatmap = L.map(mapContainerId, {

        attributionControl: false,

        zoomControl: true,

        zoomSnap: 0.05,

        minZoom: 3,

        maxZoom: 5,

        doubleClickZoom: false,

        closePopupOnClick: false,

        trackResize: false,

        touchZoom: false,

        scrollWheelZoom: false

      }).setView([20.59, 78.96], 4.5);

      L.tileLayer(

        'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiYXNlZW0zMTIiLCJhIjoiY2phdzIzcW55NXQzbDJxbnFtYXl2eXNnYiJ9.z8_v4MmPVgVFr1V42xEyqA',

        <INewTileLayerOptions>{

          id: 'mapbox.light',

        }

      ).addTo(heatmap);
      const stateLayer = L.geoJSON(geoJson)
        .setStyle({

          weight: 0.6,

          fill: true,

          fillOpacity: 0.9,

          fillColor: 'rgb(247, 247, 247)',

          color: '#485058',

        })

        .addTo(heatmap);

      console.log('backbuttonData==>', this.statesData);



      for (const item of this.statesData) {



        heatmap.eachLayer((layer: any) => {



          if (layer['feature']) {
            if (item['state_name'].toLowerCase() == layer['feature'].properties?.ST_NM?.toLowerCase()) {
              layer.setStyle({

                fillColor: 'rgb(240,84,132)',

                color: "#757b81",

                weight: 1,

                opacity: 0.75,

                // fillOpacity: 1

              });

              layer['feature'].properties['village'] = item?.district ? item?.district : 0;

              layer['feature'].properties['count'] = item?.count ? item?.count : 0;

              layer['feature'].properties['farmerAdopted'] = item?.farmerAdopted ? item?.farmerAdopted : 0;

              layer['feature'].properties['s_id'] = item?.state_id;







              layer

                .bindPopup("", { autoPan: false })

                .setPopupContent(

                  this.statesData

                    .map((item: any) => {



                      item?.state_name

                    }

                    )

                    .includes(layer['feature'].properties.id)

                    ? `

                    <div class="">

                      <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties?.ST_NM}</span></div>

                      <div class="border-bottom"><span class="custom-tooltip tooltip-title">Total Districts :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.totalDistricts ? layer['feature'].properties.totalDistricts : 0}</span></div>

                      <div class="border-bottom"><span class="custom-tooltip tooltip-title">${layer['feature'].properties.label} :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span></div>

                    </div>`

                    : `<div class="" style="margin-top:-30px;background:lightblue;margin-right:10px;padding:5%;font-weight:500;">

                        <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties?.ST_NM}<br>District : ${layer['feature'].properties.village ? layer['feature'].properties.village : 0}

                        <br>



                        </span></div>

                      </div>`,

                )

                .addTo(heatmap);



              layer.on({

                //remove float class from indivisual state on hover

                mouseout: (e: any) => {

                  this.removeFloatClass();

                },

                mouseover: () => {

                  if (item['state_name'].toLowerCase() == layer['feature'].properties?.ST_NM?.toLowerCase()) {

                    this.removeFloatClass();

                    layer._path.classList.add('float-boundary')

                  }

                  document.getElementById("info")!.innerHTML = this.statesData

                    .map((item: any) => item?.village)

                    .includes(!layer['feature'].properties.id)

                    ? `

                  <div class="shadow-sm p-3 bg-white">

                    <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties?.ST_NM}</span></div>

                    <div class="border-bottom"><span class="custom-tooltip tooltip-title">Total Districts :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.totalDistricts ? layer['feature'].properties.totalDistricts : 0}</span></div>

                    <div class="border-bottom"><span class="custom-tooltip tooltip-title">${layer['feature'].properties.label} :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span></div>

                  </div>`

                    : `<div class="" id="scroll" style="margin-top:30px;background:lightblue;z-index:100000;width:170px;margin-right:10px;padding:4%;font-weight:500;">

                   <span class="custom-tooltip tooltip-value">${layer['feature'].properties?.ST_NM}</span>

                   <br>

                        <span>No. of facilities: ${layer['feature'].properties.count ? layer['feature'].properties?.count : 0}</span><br>


                  </div>`;

                //  (<HTMLInputElement>document.getElementById('scroll')).scrollIntoView({  behavior: "instant",  block: "start", inline: "nearest" });

                },

                click: () => {

                  if (this.isStateView) {

                    document.getElementById("info")!.innerHTML = ''

                    stateLayer.clearLayers();

                    heatmap.removeLayer(stateLayer);

                    this.isStateView = false;

                    this.selectedLayer = layer.feature.properties;

                    this.makeMap(statesList, layer.feature.properties?.ST_NM, layer.feature.properties?.id);

                  }

                },

              });



            }
          }

        });



      }

      heatmap.fitBounds(stateLayer.getBounds());

    }

    else {

      geoJson = this.districtBoundaries.features.filter(

        (element: any) =>

          element.properties?.ST_NM == stateName &&

          element.properties.DISTRICT

      );

      console.log("Districts");

      document.getElementById(

        mapContainerId

      )!.outerHTML = `<div id='mapContainer' style="height: 90%;" class="bg-light shadow-map"><div class='row'><div class="col-12" style="margin-left:8px;margin-top:70px;"><button class="btn btn-action btn-sm mt-2 ml-5" id="container-back" ><img style="width: 20px;" src="https://cdn3.iconfinder.com/data/icons/glyph/227/Button-Back-1-512.png"></button></div> </div> </div>`;

      const backButtonId = `container-back`;

      const backButton: any = document.getElementById(backButtonId);

      backButton.addEventListener('click', (event: any) => {

        this.isStateView = true;

        this.handleMapBackButton();

      });

      heatmap = L.map(mapContainerId, {

        attributionControl: false,

        zoomControl: true,

        zoomSnap: 0.05,

        minZoom: 4,

        maxZoom: 6,

        doubleClickZoom: false,

        closePopupOnClick: false,

        trackResize: false,

        touchZoom: false,

        scrollWheelZoom: false

      }).setView([20.59, 78.96], 4.5);

      const stateLayer = L.geoJSON(geoJson)

        .setStyle({

          weight: 0.6,

          fill: true,

          fillOpacity: 0.9,

          fillColor: 'rgb(247, 247, 247)',

          color: '#485058',

        })

        .addTo(heatmap);

      console.log('districtdata===========>', this.districtData);



      for (const item of this.districtsData) {

        heatmap.eachLayer((layer: any) => {

          if (layer['feature']) {

            if (item['district_name']?.toLowerCase() == layer['feature'].properties?.DISTRICT.toLowerCase()) {

              layer.setStyle({

                fillColor: 'rgb(240,84,132)',

                color: "#757b81",

                weight: 1,

                opacity: 0.75,

                // fillOpacity: 1

              });

            }

            layer.on({

              click: () => {

                if (this.isStateView) {

                  stateLayer.clearLayers();

                  heatmap.removeLayer(stateLayer);

                  this.isStateView = false;

                  this.makeMap(statesList, layer.feature.properties?.ST_NM, layer.feature.properties?.id);

                }

              },

            });

          }

        });



      }

      heatmap.fitBounds(stateLayer.getBounds());

    }

    this.HEATMAP = heatmap;

    this.mapViewModeHandler(statesList, heatmap, this.selectedLayer);

  }



  handleMapBackButton() {

    this.isStateView = true;

    this.loadLegends = true;

    this.districtApiTrigger.emit();

    this.makeMap(this.statesData, '', '');

  }


/**
 * The `mapViewModeHandler` function handles the view mode for a map, either displaying state-level
 * data or district-level data.
 * @param {any} dataList - An array of data that contains information about the map view.
 * @param {any} heatmap - The `heatmap` parameter is an object that represents the heatmap data.
 * @param selectedLayer - The selectedLayer parameter is the layer that the user has selected for
 * viewing the data.
 */

  mapViewModeHandler(dataList: any, heatmap: any, selectedLayer) {

    console.log("Handle View", selectedLayer);

    if (this.isStateView) {

      this.getStateHeatMapData(dataList, heatmap);

    } else {

      this.loadLegends = true;

      this.getDistrictData(dataList, heatmap, selectedLayer);

    }

  }



  /**
   * The `getStateHeatMapData` function takes in an array of states and a heatmap object, and uses the
   * data to style the heatmap layers and add popups to the map.
   * @param {any} statesArr - An array containing information about the states. Each element in the
   * array should have the following properties:
   * @param {any} heatmap - The `heatmap` parameter is an object representing the heatmap layer on the
   * map. It is used to style and manipulate the heatmap layer.
   * @returns There is no return statement in the code provided.
   */
  getStateHeatMapData(statesArr: any, heatmap: any) {



    const prmsArr = [];

    let index = 0;

    const map = heatmap

    let dynamicLegend = statesArr.map((mapCount: any) => mapCount.count);

    let minLegend = Math.min(...dynamicLegend);

    let maxLegend: any = Math.max(...dynamicLegend);

    let avgLegend = maxLegend / 5;

    let tempGrades: any = [0]

    for (let i = 1; i < 4; i++) {

      let tempLegend: any = (minLegend) + avgLegend * i;

      tempLegend = tempLegend < 1 ? tempLegend.toFixed(2) : tempLegend.toFixed(0);

      tempGrades.unshift(tempLegend)

    }

    tempGrades.unshift(maxLegend.toFixed(0))

    console.log('statesArr', statesArr)

    const total = statesArr.reduce((cnt: any, o: any) => {

      return cnt + o.count;

    }, 0);

    console.log('total', total)

    for (const item of statesArr) {

      map.eachLayer((layer: any) => {

        if (layer['feature']?.properties?.id &&  (item['state_name'].toLowerCase() == layer['feature'].properties?.ST_NM.toLowerCase()) ) {

          layer.setStyle({

            fillColor: getColorCode(item.count, tempGrades),

            color: "#757b81",

            weight: 1,

            opacity: 0.75,

            // fillOpacity: 1

          });

          switch (layer['feature'].properties.id) {

            case item['state_name']:

              layer['feature'].properties['count'] = item.count;

              layer['feature'].properties['totalDistricts'] = item.total_districts ? item.total_districts : 0;

              layer['feature'].properties['label'] = item.label ? item.label : "Cases";

              console.log("map data", item);

              let count;

              // isNaN(item['count'] / total)

              //   ? (count = 0)

              //   : (count = item['count'] / total);

              isNaN(item['count'] / total)

                ? (count = 0)

                : (count = item['count']);

              // layer.setStyle({

              //   fillColor: getColorCode(item['count'], tempGrades),

              //   color: "#757b81",

              //   weight: 1,

              //   opacity: 0.5,

              //   fillOpacity: 1

              // });

              break;

            default:

          }



          layer

            .bindPopup("", { autoPan: false })

            .setPopupContent(

              this.statesData

                .map((item: any) => {



                  item.state_name?.toLowerCase()

                }

                )

                .includes(layer['feature'].properties.ST_NM?.toLowerCase())

                ? `

                    <div class="">

                      <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties.ST_NM}</span></div>

                      <div class="border-bottom"><span class="custom-tooltip tooltip-title">Total Districts :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.totalDistricts ? layer['feature'].properties.totalDistricts : 0}</span></div>

                      <div class="border-bottom"><span class="custom-tooltip tooltip-title">${layer['feature'].properties.label} :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span></div>

                    </div>`

                : `<div class="" style="margin-top:75px;background:lightblue;margin-right:10px;padding:5%;font-weight:500;">

                        <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties.ST_NM}<br>District : ${layer['feature'].properties.village ? layer['feature'].properties.village : 0}

                        <br>


                        
                        </span></div>

                      </div>`,

            )

            .addTo(heatmap);



          layer.on({

            //remove float class from indivisual state on hover

            mouseout: (e: any) => {

              this.removeFloatClass();

            },

            mouseover: () => {

              if (item['state_name'].toLowerCase() == layer['feature'].properties?.ST_NM?.toLowerCase()) {

                this.removeFloatClass();

                layer._path.classList.add('float-boundary')

              }

              if (layer['feature'].properties.farmerReached && layer['feature'].properties.farmerAdopted)

                document.getElementById("info")!.innerHTML = this.statesData

                  .map((item: any) => item.village)

                  .includes(!layer['feature'].properties.id)

                  ? `

                  <div class="shadow-sm p-3 bg-white">

                    <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties?.ST_NM}</span></div>

                    <div class="border-bottom"><span class="custom-tooltip tooltip-title">Total Districts :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.totalDistricts ? layer['feature'].properties.totalDistricts : 0}</span></div>

                    <div class="border-bottom"><span class="custom-tooltip tooltip-title">${layer['feature'].properties.label} :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span></div>

                  </div>`

                  : `<div class="" style="margin-top:20px;background:lightblue;z-index:100000;width:170px;margin-right:10px;padding:4%;;font-weight:500;">

                   <span class="custom-tooltip tooltip-value">${layer['feature'].properties?.ST_NM}<br>District : ${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span>

                   <br>


                       
                  </div>`;

            },



          });



        }

      });

    }

    map.on({

      mouseout: () => {
        document.getElementById("info")!.innerHTML = "";

        this.removeFloatClass();

      }

    });

    if (this.isLegendsVisible) {

      console.log('isLegendsVisible called')

      var legend = new L.Control({ position: 'bottomright' });

      const mContext = this;

      legend.onAdd = function (map) {



        var div = L.DomUtil.create('div', 'info legend'),

          grades = [...tempGrades],

          labels = [],

          from, to;

        for (var i = 0; i < grades.length - 1; i++) {

          from = grades[i];

          to = grades[i + 1];

          labels.push(

            `<div class="legends-body" >

                        <i style="background: ${getLegendColorCode(i)}" ></i>

                        <span> ${to}${"-" + from}</span>

                      </div>`

          );

        }



        div.innerHTML = labels.join('');

        return div;

      };

      legend.addTo(map);

    }

    // get color depending on population density value

    function getColorCode(d: any, grades = []) {

      let liesIndex = -1

      grades.forEach((item, index) => {

        if (index > 0 && d > parseFloat(item) && liesIndex == -1) {

          liesIndex = index

        }

      })



      liesIndex = liesIndex ? liesIndex : 0;

      console.log("gggtd", d, liesIndex, grades)

      return getLegendColorCode(liesIndex)

      // return maxLegend/d > 0 &&   maxLegend/d  < 0.9 ? '#337AB7' :

      // maxLegend/d > 0.9   && maxLegend/d < 1.9? '#5b94c4' :

      // maxLegend/d > 1.9  && maxLegend/d < 2.9 ? '#83add2' :

      // maxLegend/d > 2.9  && maxLegend/d < 3.9? '#a9c6de' :

      //           '#d1dfec';

    }



    function getLegendColorCode(i: any) {

      return i == 4 ? '#FDE7EE' :

         i == 3 ? '#F8A1BB' :

           i == 2 ? '#F47299' :

             i == 1 ? '#F04377' :

               '#ED1556';

              return i == 0 ? '#337AB7' :

        i == 1 ? '#5b94c4' :

          i == 2 ? '#83add2' :

            i == 3 ? '#a9c6de' :

              '#d1dfec';

    }



    function getBorderColorCode(d: any) {

      return d > 1500 ? '#206fb2' :

        d > 1000 ? '#4389c4' :

          d > 500 ? '#619ed3' :

            d > 300 ? '#8db8dc' :

              '#b5cee5';

    }



    if (this.disableDragging)

      map.dragging.disable();

  }



  /**
   * The function `getDistrictData` logs the selected layer and emits an event with the selected layer
   * as a parameter.
   * @param {any} dataList - The `dataList` parameter is of type `any` and is used to pass a list of
   * data to the `getDistrictData` function.
   * @param {any} heatmap - The `heatmap` parameter is an object that represents the heatmap data. It
   * is used to visualize data on a map by assigning colors to different values.
   * @param {any} selectedLayer - The selectedLayer parameter is a variable that represents the
   * currently selected layer in the application. It is used to determine which district data to
   * retrieve from the API.
   */
  async getDistrictData(dataList: any, heatmap: any, selectedLayer: any) {

    console.log("District API", this.selectedLayer);

    if (this.selectedLayer) {
      this.districtApiTrigger.emit(this.selectedLayer);

    }

  }



 /**
  * The `getDistrictHeatMapData` function takes in an array of district data and a heatmap object, and
  * uses this data to populate the heatmap with color-coded districts based on the count values.
  * @param {any} districtArr - The districtArr parameter is an array that contains information about
  * each district. Each element in the array represents a district and includes properties such as
  * district_name, count, farmerAdopted, farmerReached, and label.
  * @param {any} heatmap - The `heatmap` parameter is the object that represents the map on which the
  * district heat map will be displayed. It is used to add layers, set styles, bind popups, and handle
  * events on the map.
  * @returns The function does not have a return statement, so it does not return anything.
  */
  getDistrictHeatMapData(districtArr: any, heatmap: any) {
    console.log("District Map Call");

    const map = heatmap;

    let dynamicLegend = districtArr.map((mapCount: any) => mapCount.count);

    let minLegend = Math.min(...dynamicLegend);

    let maxLegend: any = Math.max(...dynamicLegend);

    let avgLegend = maxLegend / 5;

    let tempGrades: any = [0]

    for (let i = 1; i < 4; i++) {

      let tempLegend: any = (minLegend) + avgLegend * i;

      tempLegend = tempLegend < 1 ? tempLegend.toFixed(2) : tempLegend.toFixed(0);

      tempGrades.unshift(tempLegend)

    }

    tempGrades.unshift(maxLegend.toFixed(0));

    const total = districtArr.reduce((cnt: any, o: any) => {

      return cnt + o.count;

    }, 0);

    console.log("tempGrades", tempGrades, districtArr)

    for (let item of districtArr) {


      map.eachLayer((layer: any) => {

        if (layer['feature']) {

          console.log('layerfeatureprop==>', layer['feature'].properties)

          if (item['district_name']?.toLowerCase() == layer['feature'].properties?.DISTRICT.toLowerCase()) {

            layer['feature'].properties['count'] = item.block;

            layer['feature'].properties['count'] = item.count ? item.count : 0;

            layer['feature'].properties['farmerAdopted'] = item.farmerAdopted ? item.farmerAdopted : 0;

            layer['feature'].properties['farmerReached'] = item.farmerReached ? item.farmerReached : 0;

            layer['feature'].properties['label'] = item.label ? item.label : "Cases";

            let count;

            isNaN(item['count'] / total) ? (count = 0) : (count = item['count'] / total);

            layer.setStyle({

              fillColor: getColorCode(item['count'], tempGrades), //'rgb(249,153,213)',

              color: "#757b81",

              weight: 1,

              opacity: 0.75,

            });

            layer

              .bindPopup("", { autoPan: false })

              .setPopupContent(

                this.districtsData

                  .map((item: any) => {



                    item.censuscode

                  }

                  )

                  .includes(layer['feature'].properties.censuscode)

                  ? `

                <div class="">

                  <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties.DISTRICT}</span></div>

                  <div class="border-bottom"><span class="custom-tooltip tooltip-title">No.of facilities :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.count ? layer['feature'].properties.count : 0}</span></div>

                

                </div>`

                  : `<div class="d-none" style="border: none;">

                    <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties.DISTRICT}<br>Block : ${layer['feature'].properties.count ? layer['feature'].properties.count : 0}

                    <br>

                   

                   
                    </span></div>

                  </div>`,

              )

              .addTo(heatmap);



            layer.on({

              //remove float class from indivisual state on hover

              mouseout: (e: any) => {

                this.removeFloatClass();

              },

              mouseover: () => {

                if (item['district_name'].toLowerCase() == layer['feature'].properties?.DISTRICT.toLowerCase()) {

                  this.removeFloatClass();

                  layer._path.classList.add('float-boundary')

                }

                document.getElementById("info")!.innerHTML = this.districtsData

                  .map((item: any) => item.village)

                  .includes(!layer['feature'].properties.id)

                  ? `

              <div class="shadow-sm p-3 bg-white">

                <div class="border-bottom text-center title"><span class="custom-tooltip title" >${layer['feature'].properties.DISTRICT}</span></div>

                <div class="border-bottom"><span class="custom-tooltip tooltip-title">Total Districts :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.totalDistricts ? layer['feature'].properties.totalDistricts : 0}</span></div>

                <div class="border-bottom"><span class="custom-tooltip tooltip-title">${layer['feature'].properties.label} :</span> <span class="custom-tooltip tooltip-value">${layer['feature'].properties.village ? layer['feature'].properties.village : 0}</span></div>

              </div>`

                  : `<div class="" style="margin-top:20px;background:lightblue;z-index:100000;width:170px;margin-right:10px;padding:4%;;font-weight:500;">

               <span class="custom-tooltip tooltip-value">${layer['feature'].properties.DISTRICT}<br>No. of facilities : ${layer['feature'].properties.count ? layer['feature'].properties.count : 0}</span>

               <br>
              </div>`;

              },

              click: (e: any) => {



                this.removeFloatClass();

              }

            });



          }

        }

      });

    };

    map.on({

      mouseout: () => {
        map.closePopup(); document.getElementById("info")!.innerHTML = "";

        this.removeFloatClass();

      }

    });

    // if (this.isLegendsVisible && this.loadLegends ) {

    if (document.getElementsByClassName('info') && document.getElementsByClassName('info').length)

      document.getElementsByClassName('info')[0].remove()

    console.log("legends");

    if (this.isLegendsVisible) {

      console.log('isLegendsVisible called')

      var legend = new L.Control({ position: 'bottomright' });

      const mContext = this;

      legend.onAdd = function (map) {



        var div = L.DomUtil.create('div', 'info legend'),

          grades = [...tempGrades],

          labels = [],

          from, to;

        for (var i = 0; i < grades.length - 1; i++) {

          from = grades[i];

          to = grades[i + 1];

          labels.push(

            `<div class="legends-body" >

                        <i style="background: ${getLegendColorCode(i)}" ></i>

                        <span> ${to}${"-" + from}</span>

                      </div>`

          );

        }



        div.innerHTML = labels.join('');

        return div;

      };

      legend.addTo(map);

    }



    function getColorCode(d: any, grades = []) {

      let liesIndex = -1

      grades.forEach((item, index) => {

        if (index > 0 && d > parseFloat(item) && liesIndex == -1) {

          liesIndex = index

        }

      })



      liesIndex = liesIndex ? liesIndex : 0;

      console.log("gggtd", d, liesIndex)

      return getLegendColorCode(liesIndex);
    }



    function getLegendColorCode(i: any) {

      // return i == 4 ? '#fcdcfc' :

      //   i == 3 ? '#f7a8f7' :

      //     i == 2 ? '#f485f4' :

      //       i == 1 ? '#f373f3' :

      //         '#f051f0';

     return i == 4 ? '#FDE7EE' :

         i == 3 ? '#F8A1BB' :

           i == 2 ? '#F47299' :

             i == 1 ? '#F04377' :

               '#ED1556';
              return i == 0 ? '#337AB7' :

        i == 1 ? '#5b94c4' :

          i == 2 ? '#83add2' :

            i == 3 ? '#a9c6de' :

              '#d1dfec';

    }

  }



  removeFloatClass() {

    let leafletFloat = document.getElementsByClassName('leaflet-interactive');

    for (let index = 0; index < leafletFloat.length; index++) {

      if (document.getElementsByClassName('leaflet-interactive')[index].classList.contains('float-boundary'))
        document.getElementsByClassName('leaflet-interactive')[index].classList.remove('float-boundary')
    }

  }



}